module.exports = __webpack_public_path__ + "img/manufacturing-pathway.ef1a9684.jpg";